<div
  class="overlay"
  [class.overlay--transparent]="spinnerType === 'transparent'"
  [class.overlay--viewport]="viewportCenter">
  <div class="viewport-anchor" *ngIf="viewportCenter">
    <p-progressSpinner styleClass="custome-spinner"></p-progressSpinner>
  </div>
  <p-progressSpinner *ngIf="!viewportCenter" styleClass="custome-spinner"></p-progressSpinner>
</div>
